import classNames from 'classnames';
import { FunctionComponent, MouseEventHandler } from 'react';
import { StarSolidIcon } from '../../Icons';
import styles from '../styles.module.scss';

export type StarProps = {
    checked: boolean;
    value: number;
    onClick?: (rating: number) => void;
};

const Star: FunctionComponent<StarProps> = ({ checked, value, onClick }) => {
    const label = onClick ? `Rate ${value}` : undefined;
    const checkedClassName = checked ? styles.checked : styles.unchecked;

    const onClickHandler: MouseEventHandler<HTMLButtonElement> = (event) => {
        event.preventDefault();

        if (onClick) {
            onClick(value);
        }
    };

    return (
        <button
            className={classNames(styles.star, checkedClassName)}
            onClick={onClickHandler}
            aria-label={label}
            title={label}
            type="button"
        >
            <StarSolidIcon />
        </button>
    );
};

export default Star;
